module.exports = __webpack_public_path__ + "media/dashboard/assets/images/dev-productivity-2c3facbe4685e042855ab34224c47769.svg";